module.exports = __webpack_public_path__ + "img/MU.5d393234.svg";